export default "__VITE_ASSET__a8ed2c33__"